import React from 'react';

import Sidebar from '../Sidebar';

import '../Sidebar/Sidebar.scss';
import './MobileDrawer.scss';

const MobileDrawer: React.FC = () => {
  return (
    <div className="drawer-sidebar-container">
      <Sidebar collapsed={false} />
    </div>
  );
};

export default MobileDrawer;
